import React, { useEffect, useState } from "react";
import Header1 from "../../Components/seperate Components/Header1";
import { faCheck, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "../../Components/Footer";
import "../../Styles/Redirecting Styles/NavbarStyles/Bespoke.css";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { animateScroll as scroll } from "react-scroll";
import Shape2 from "../../assets/brand/choose-shape-2.png";
// import solutions from "../../assets/All Images/solutions.jpg";
// import solutions1 from "../../assets/All Images/solutions1.jpg";
// import solutions2 from "../../assets/All Images/solutions2.jpg";
import Angular from "../../assets/icons/angular.png";
import nodeJs from "../../assets/icons/nodejs.png";
import linuxServer from "../../assets/icons/linuxserver.png";
import filezilla from "../../assets/icons/filezilla.png";
import flutter from "../../assets/icons/flutter.png";
import php from "../../assets/icons/php.png";
import postman from "../../assets/icons/postman.png";
import ownership from "../../assets/icons/ownership.png";
import react from "../../assets/icons/react.png";
import xcode from "../../assets/icons/xcode.png";
import windows from "../../assets/icons/windows.png";
import visualStudio from "../../assets/icons/visual-studio.png";
import trophy from "../../assets/icons/trophy.png";
import verticalScalability from "../../assets/icons/vertical-scalability.png";
import computerIntegration from "../../assets/icons/computer-integration.png";
import netDomain from "../../assets/icons/net-domain.png";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Helmet } from "react-helmet";

const BespokeSystem = () => {
  const toggleContact = () => {
    scroll.scrollToTop(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
          Leading Custom Software Development Company | Top ERP & CRM Solutions
        </title>
        <meta
          name="description"
          content="Find India’s top custom software development company, offering CRM software, ERP systems, and tailored solutions to meet your business needs."
        />
        <meta
          name="keywords"
          content="Tailored software solutions, bespoke software development, customized software services, leading custom software development company, top software development firm, best software development provider, trusted software company, professional software solutions, custom software experts, CRM software solutions, top ERP systems."
        />
      </Helmet>

      <Header1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg1 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#01536E" }}
                >
                  Custom Software Development Expert
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Working with a custom software development company boosts
                      operational efficiency and helps businesses grow their
                      profits.
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First Section */}

      <section className="bd-about-area">
        <div className="bd-custom-container">
          <div className="bd-about-four-bg  pt-80 pb-0 fix">
            <div className="bd-about-shape-box">
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-8 first_resp_bespoke">
                    <div className="bd-choose-img text-end mb-30 top-resp z-index">
                      <div className="row align-items-center custom-mar-15">
                        <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                          <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                            <img
                              // src={solutions}
                              className="resp-img bordertop-img1"
                              alt="img not found"
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                          <div className="bd-choose-img-inner mb-15">
                            <img
                              // src={solutions1}
                              className="resp-img bordertop-img2"
                              alt="img not found"
                            />
                          </div>
                          <div className="bd-choose-img-inner mb-15">
                            <img
                              // src={solutions2}
                              className="resp-img bordertop-img3"
                              alt="img not found"
                            />
                          </div>
                        </div>
                      </div>
                      <img
                        className="bd-choose-shape bd-choose-shape-2"
                        src={Shape2}
                        alt="shape img not found"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-8 second_resp_bespoke">
                    <div className="bd-about-text bd-about-text-four mb-40 z-index">
                      <div className="bd-section-title-wrapper">
                        <h2 className="bd-section-title mb-15 md-pr-50">
                          Drive success with tailor-made{" "}
                          <span style={{ color: "#098FB4" }}>
                            software solutions{" "}
                          </span>
                        </h2>
                        <p className="">
                          Custom software solutions are designed to fit a
                          company’s unique needs, ensuring smooth and efficient
                          operations. They help businesses streamline processes,
                          enhance productivity, and stay ahead in the market.
                          With the flexibility to adapt to changing trends and
                          market demands, custom software supports long-term
                          business success.
                        </p>
                        <p>
                          Custom software isn’t just about efficiency—it’s about
                          future-proofing your business. In today’s
                          fast-changing tech world, off-the-shelf solutions can
                          become outdated fast. But with custom software, your
                          business can adapt and scale as it grows. Plus, it
                          offers stronger data security, which is crucial in
                          today’s interconnected landscape.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <ModalVideo
          autoplay
          isOpen={isOpen}
          channel="youtube"
          videoId="6wrgJR1n5ao"
          onClose={() => setOpen(false)}
        ></ModalVideo>
        <button
          className="btn btn touch_pop_vid first_pop_video_bespoke"
          onClick={() => setOpen(true)}
        >
          <FontAwesomeIcon
            icon={faPlay}
            className="play_bt_vid play_transition"
          />
        </button> */}
      </section>

      {/* <!-- about area start here --> */}
      <section className="bd-about-six-area ">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <h2 className="bd-section-title mb-25 bespoke_section2-tittle">
            Get tailored software solutions for your business.
          </h2>
          <div className="row bespoke_responsive">
            <div className="col-lg-6 first_section_responsive ">
              <div className="bd-about-six-text">
                <div className="bd-section-title-wrapper mb-25">
                  <p>
                    In today’s fast-changing business world, having the right
                    software solutions is more important than ever. Every
                    business has its own challenges, goals, and operations.
                    Ready-made software may be convenient, but it often doesn’t
                    fully meet these unique needs. That’s where customised
                    software solutions come in. With tailored software
                    development, your business gets a solution that’s specially
                    designed to fit your exact requirements.
                  </p>
                  <p>
                    Once you’ve identified the key features and applications
                    your business needs, the next step is to find a reliable
                    development partner who can deliver top-quality services.
                    Choosing the right partner is crucial, as they will handle
                    the development, testing, and launch of your custom software
                    solution. Working with a trusted development team ensures
                    your solution aligns with your business goals and
                    objectives. Plus, in today’s digital world, security is more
                    important than ever. Custom software allows you to implement
                    strong security measures, safeguard sensitive data, and
                    position your business for long-term success in a highly
                    competitive market.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-8 second_section_responsive">
              <div className="bd-about-six-img">
                <div className="bd-about-six-feature">
                  <ul className="mb-45">
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Customised Solutions
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Growth & scalability
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Maximised ROI
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Time Efficiency
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Competitive Edge
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Seamless Integration
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Easy Maintenance
                    </li>
                    <li
                      style={{
                        fontSize: "18px",
                        color: "var(--clr-body-text)",
                      }}
                    >
                      <i>
                        <FontAwesomeIcon icon={faCheck} />
                      </i>{" "}
                      Greater Independence
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* choose section */}
      <section className="bd-choose-area fix">
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape pt-70">
            <div className="row four_resp_section">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 four_point_section1">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <div className="bd-choose-img z-index pt-50">
                  <div className="bd-choose-info-wrapper">
                    <div className="container">
                      <div className="row mb-50">
                        <div className="col cell_resp mr-30">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={verticalScalability} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Scalability and flexibility
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={ownership} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Complete ownership
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container">
                      <div className="row">
                        <div className="col cell_resp mr-30">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={computerIntegration} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Fast integration
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col respon_space">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src={trophy} />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Competitive advantage
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 mt-0 four_point_section2">
                <div className="bd-choose-text z-index">
                  <h2 className="bd-section-title section_title2">
                    Advantages of Tailor-Made Software Solutions
                  </h2>
                  <div className="bd-section-title-wrapper">
                    <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                      Custom software solutions give businesses a strategic
                      advantage by delivering tailored functionalities. Designed
                      to fit unique workflows and business needs, these
                      solutions streamline operations and enhance productivity.
                      Their personalized approach improves efficiency,
                      simplifies user experience, and reduces training
                      time—ensuring smooth adoption and greater innovation.
                    </p>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fifth Section */}

      {/* <section className="bd-about-area">
                <div className="bd-custom-container" >
                    <div className="bd-about-four-bg  pt-80 pb-70 fix">
                        <div className="bd-about-shape-box">
                            <div className="container" style={{ maxWidth: "1270px" }}>
                                <div className="row justify-content-center">

                                    <div className="col-xl-6 col-lg-8 fifth_section_respon">
                                        <div className="bd-about-text bd-about-text-four mb-40 z-index">
                                            <div className="bd-section-title-wrapper">

                                                <h2 className="bd-section-title mb-15 bespoke-lastSection_tittle md-pr-50">Make Business Stand out with our Unique Bespoke Solution</h2>
                                                <p className="">With a customized system in place, businesses can save money, and time and have greater control over their operations. From the initial design to the final delivery, our team of experts will help make sure your business is using the right system for the right reasons. From a simple website design to a customized marketing plan, our team can help you get the system that is right for you. With our customized system, you can save time and improve effectiveness. You can also improve your working procedures and manage your business better. Our system is designed to help you grow your business and grow your profits.</p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-8 pl-30 fifth_section_respon2">
                                        <div className="bd-about-img mb-30">
                                            <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659412855/website/bespoke-system/bespoke-system-sec-2_ev7qgp.jpg" style={{ height: "470px" }} className="xss-w-full rounded-10" alt="about img not found" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
      <section className="bd-service-area pb-70 pt-70">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row"></div>
          <div className="row sixth-main-responsive">
            <h2 className="mb-30 sixth-section-soft">
              Tools and technologies involved in the process.
            </h2>
            <div className="col-lg-4 col-md-6 sixth-soft-section1">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <p>
                  Commonly used tools in software development include resources
                  like Git, code management platforms such as GitLab, and build
                  management systems like Jenkins.
                </p>
                <table style={{ marginLeft: "50px" }}>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td className="pb-30" style={{ width: "180px" }}>
                        <img src={filezilla} />
                      </td>
                      <td className="pb-30" style={{ width: "180px" }}>
                        <img src={visualStudio} width={64}/>
                      </td>
                      <td className="pb-30">
                        <img src={windows} width={64} />
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <img src={linuxServer} />
                      </td>
                      <td>
                        <img src={xcode} width={64} />
                      </td>
                      <td>
                        <img src={postman} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 sixth-soft-section1">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <p>
                  In the world of business processes, there's a wide range of
                  technologies to tap into. These include software development
                  tools, various programming languages, and a diverse set of
                  application development frameworks.
                </p>
                <table style={{ marginLeft: "50px" }}>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td className="pb-30" style={{ width: "180px" }}>
                        <img src={netDomain} />
                      </td>
                      <td className="pb-30" style={{ width: "180px" }}>
                        <img src={Angular} />
                      </td>
                      <td className="pb-30">
                        <img src={nodeJs} />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <img src={flutter} />
                      </td>
                      <td>
                        <img src={php} />
                      </td>
                      <td>
                        <img src={react} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <ServiceBanner/> */}

      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#01536E" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Need a custom software development expert?
                </h2>
                <p className="contact_section second-para-resp">
                  You’re here at the perfect moment.
                </p>
                <p className="contact_subtext">
                  Top-notch developers, let’s get started now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+65 87852030"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +65 87852030
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BespokeSystem;
